import { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';
import ServiceSubNav from '@/components/base/ServiceSubNav';

const SERVICE_SUBNAV_ITEMS = [
  { label: '熱銷配方', path: '/services/hot-formulas' },
  { label: '天然原料', path: '/services/natural-ingredients' },
  { label: '各類劑型', path: '/services/dosage-forms' },
  { label: '包裝設計', path: '/services/packaging' },
];

const dosageForms = [
  {
    id: 'powder',
    anchor: 'powder',
    icon: 'ri-contrast-drop-line',
    title: '粉劑',
    subtitle: '溶解快速、攝取直觀',
    desc: '粉末劑型將原料研磨成細粉或顆粒狀，可直接衝泡飲用或加入食物中，適合每日攝取量較高的成分或需要快速吸收的配方。',
    process: '原料混合 → 入鋁袋 → 入彩盒 → 裝箱出貨\n可選多種包裝樣式(鋁包：三面封、水平封、背封、夾鏈鋁袋；罐裝)',
    suitable: ['健身助力', '好菌加倍', '兒童成長', '毛孩專屬'],
    advantages: ['攝取量靈活可調', '易於添加調味', '適合大量補充', '沖泡方便快速'],
    note: '粉末容易受潮，包裝需特別注意防潮設計，保存環境建議低溫低濕。',
    img: 'https://readdy.ai/api/search-image?query=powder%20supplement%20scoop%20protein%20nutrition%20powder%20white%20powder%20in%20glass%20jar%20with%20spoon%20on%20clean%20white%20marble%20surface%2C%20health%20supplement%20product%20photography%20minimal&width=600&height=380&seq=df-powder-01&orientation=landscape',
    color: '#fff59d',
    colorDark: '#f9a825',
  },
  {
    id: 'tablet',
    anchor: 'tablet',
    icon: 'ri-medicine-bottle-line',
    title: '錠劑',
    subtitle: '攜帶便利、劑量精準',
    desc: '錠劑透過壓錠成型，外觀固定、劑量穩定，是市面上最普及的保健食品劑型。可製作多種形狀（圓形、橢圓形）並加入包衣提升外觀與口感。',
    process: '打錠\n膜衣→ 依需求→ 數粒填充→ (PTP 包裝 )→入鋁袋→ 入彩盒→ 裝箱出貨\n形狀樣式：圓形、橢圓形、長條型、三角形\n小錠(吞服):250mg 、 300mg 、 350mg\n中錠(吞服/ 咀嚼): 400mg 、 500mg 、 700mg 、 800mg\n大錠(咀嚼): 900mg 、 1g 、 1200mg 、 1500mg 、 2g',
    suitable: ['強力防護', '日常營養', '毛孩專屬'],
    advantages: ['生產效率高、成本具競爭力', '攜帶攜存方便', '劑量精確穩定', '可添加包衣控制崩散速度'],
    note: '部分原料不適合高溫壓錠製程，需在配方設計階段確認原料耐熱性。',
    img: 'https://readdy.ai/api/search-image?query=supplement%20tablets%20pills%20various%20colors%20shapes%20round%20oval%20on%20white%20background%2C%20pharmaceutical%20health%20product%20close%20up%20photography%2C%20clean%20minimal%20style&width=600&height=380&seq=df-tablet-01&orientation=landscape',
    color: '#c8e6c9',
    colorDark: '#2e7d32',
  },
  {
    id: 'capsule',
    anchor: 'capsule',
    icon: 'ri-capsule-line',
    title: '膠囊',
    subtitle: '遮味效果佳、消費者接受度高',
    desc: '膠囊可分為硬膠囊（填充粉末或顆粒）與軟膠囊（填充油脂類原料），是目前保健食品市場接受度最高的劑型之一，能有效遮蔽原料苦澀氣味。',
    process: '膠囊填充\n數粒填充 → (PTP 包裝) → 入鋁袋 → 入彩盒 → 裝箱出貨\n顏色樣式：請洽詢服務專員\n一般膠囊(明膠+ 純水)\n#00：長度 (23.3mm) / 厚度 (1.15mm) / 適合填充重量 (850~1000mg)\n#0：長度 (21.3mm) / 厚度 (1.05mm) / 適合填充重量 (500~800mg)\n#1：長度 (19.2mm) / 厚度 (1mm) / 適合填充重量 (350~450mg)\n植物性膠囊(素食)\n#00：長度 (23.3mm) / 厚度 (1.15mm) / 適合填充重量 (900~1200mg)\n#0：長度 (21.3mm) / 厚度 (1.05mm) / 適合填充重量 (600~800mg)\n#1：長度 (19.2mm) / 厚度 (1mm) / 適合填充重量 (350~550mg)',
    suitable: ['植物萃取', '男女保健', '窈窕纖美', '日常營養', '水潤晶亮', '毛孩專屬'],
    advantages: ['有效遮蔽原料異味', '植物性 / 動物性膠囊可選', '外觀美觀易識別', '油脂類原料首選劑型'],
    note: '軟膠囊製程較硬膠囊複雜，交期稍長，如有製作需求請洽詢專員 ；植物性膠囊適合素食者，可作為差異化賣點。',
    img: 'https://readdy.ai/api/search-image?query=top%20down%20flat%20lay%20photography%20of%20green%20and%20transparent%20health%20supplement%20gelatin%20capsules%20spilling%20out%20from%20an%20open%20dark%20amber%20glass%20jar%20onto%20a%20smooth%20light%20beige%20marble%20surface%2C%20morning%20sunlight%20casting%20gentle%20shadows%20from%20left%20side%2C%20fresh%20green%20eucalyptus%20branch%20on%20the%20edge%20for%20natural%20wellness%20vibe%2C%20professional%20pharmaceutical%20product%20photography%20with%20shallow%20depth%20of%20field%20on%20foreground%20capsules%2C%20clean%20modern%20luxury%20aesthetic&width=600&height=380&seq=df-capsule-03&orientation=landscape',
    color: '#b2dfdb',
    colorDark: '#00695c',
  },
  {
    id: 'jelly',
    anchor: 'jelly-stick',
    icon: 'ri-drop-line',
    title: '果凍條',
    subtitle: '口感佳、市場接受度廣',
    desc: '果凍條（Jelly Stick）以膠凍劑為基底，將有效成分包覆其中，直接咬食或吸食，口感好且不需配水，深受兒童、年長者與追求便利性的消費者喜愛。',
    process: '果凍膠體 → 入鋁袋 → 入彩盒 → 裝箱出貨\n可選多種鋁包封口樣式(三面封、水平封、背封 )，其三款皆可搭配原角，鋁包樣式可選擇客供或公版袋',
    suitable: ['天然美肌', '水潤晶亮', '順暢輕盈', '頂上煩惱'],
    advantages: ['依產品成分性質，可不配水直接食用', '口感好調味選擇多', '適合兒童與高齡族群', '產品差異化明顯'],
    note: '果凍條含水量較高，保存期限通常較粉劑或錠劑短，包裝防腐設計需特別注意。',
    img: 'https://readdy.ai/api/search-image?query=health%20supplement%20jelly%20stick%20gel%20collagen%20beauty%20product%20individual%20packet%20stick%20pouch%20on%20light%20background%2C%20fresh%20colorful%20fruit%20flavored%20health%20jelly%20product%20photography&width=600&height=380&seq=df-jelly-01&orientation=landscape',
    color: '#f8bbd0',
    colorDark: '#ad1457',
  },
  {
    id: 'tea',
    anchor: 'tea-bag',
    icon: 'ri-cup-line',
    title: '茶包',
    subtitle: '天然質感、沖泡即飲',
    desc: '茶包劑型將乾燥植物原料或粉末充填於透析濾袋 中，保留天然植物的外觀與香氣，適合以「天然」、「草本」為品牌訴求的產品定位，具有良好的市場差異化效果。',
    process: '茶葉 → 原料 → 入濾袋 → 入鋁袋 → 入彩盒 → 裝箱出貨\n可選多種茶包樣式(立體茶包、雙層棉帶線標茶包、雙層棉茶包)',
    suitable: ['順暢輕盈', '安心凝神', '日常營養'],
    advantages: ['天然草本質感強', '視覺吸引力高', '適合品牌故事行銷', '原料呈現直觀'],
    note: '茶包劑型對原料的粒度與充填均勻度有特殊要求，部分有效成分在熱水沖泡中的溶出率需事先評估。',
    img: 'https://readdy.ai/api/search-image?query=warm%20overhead%20flat%20lay%20of%20loose%20leaf%20herbal%20tea%20blend%20with%20dried%20chamomile%20flowers%20goji%20berries%20and%20green%20tea%20leaves%20inside%20a%20clear%20glass%20teacup%20with%20stainless%20steel%20mesh%20infuser%2C%20scattered%20dried%20botanicals%20on%20a%20light%20oak%20wooden%20table%2C%20steam%20rising%20from%20hot%20water%2C%20golden%20hour%20backlight%20from%20window%20creating%20warm%20atmospheric%20glow%2C%20organic%20wellness%20drink%20concept%20photography%2C%20high%20end%20natural%20product%20styling%20with%20linen%20fabric%20texture%20underneath&width=600&height=380&seq=df-tea-03&orientation=landscape',
    color: '#d7ccc8',
    colorDark: '#4e342e',
  },
  {
    id: 'liquid',
    anchor: 'liquid',
    icon: 'ri-water-percent-line',
    title: '液劑',
    subtitle: '吸收快速、適合特定族群',
    desc: '液態劑型包含口服液、飲品、滴劑等形式，有效成分溶解於液體中，吸收速度快，特別適合嬰幼兒、高齡者或對吞嚥有困難的使用族群。',
    process: '原料溶解配製 → 入鋁袋 → 膠囊 → 特殊飲用式鋁袋 → 瓶裝 → 入彩盒 → 裝箱出貨\n相關資訊歡迎洽詢服務專員',
    suitable: ['寶寶配方', '兒童成長', '天然美肌', '日常營養'],
    advantages: ['吸收速度最快', '適合特殊族群使用', '可添加風味調配', '外觀辨識度高'],
    note: '液態製程對微生物管控要求最嚴，需確保充填環境達到食品級標準，保存期限也需充分驗證。',
    img: 'https://readdy.ai/api/search-image?query=sleek%20modern%20aluminum%20stick%20pouch%20liquid%20health%20supplement%20vitamin%20drink%20standing%20upright%20on%20a%20smooth%20light%20concrete%20surface%2C%20side%20angle%20product%20photography%20with%20a%20small%20pour%20of%20colorful%20berry%20red%20liquid%20on%20the%20surface%20next%20to%20it%2C%20bright%20clean%20daylight%20studio%20lighting%20from%20right%20side%2C%20professional%20nutraceutical%20wellness%20product%20commercial%20shot%2C%20minimalist%20contemporary%20composition%20with%20negative%20space%2C%20premium%20quality%20liquid%20supplement%20packaging&width=600&height=380&seq=df-liquid-03&orientation=landscape',
    color: '#b3e5fc',
    colorDark: '#0277bd',
  },
];

export default function DosageFormsContent() {
  const [openDetail, setOpenDetail] = useState<string | null>(null);

  return (
    <>
      {/* Hero */}
      <section className="relative pt-20 min-h-[360px] md:min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20health%20supplement%20dosage%20forms%20capsules%20tablets%20powder%20jelly%20drink%20arranged%20together%20on%20clean%20white%20surface%2C%20professional%20pharmaceutical%20product%20display%20photography%20natural%20light&width=1920&height=420&seq=df-hero-bg-01&orientation=landscape"
            alt="各類劑型背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <Breadcrumb
              items={[
                { label: '首頁', href: '/' },
                { label: '代工服務', href: '/services' },
                { label: '各類劑型' },
              ]}
              className="mb-4 text-gray-300"
            />
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              代工服務
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              各類劑型
            </h1>
            <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              針對不同配方原料特性與產品訴求，選擇適合的劑型，讓營養更適合被使用者接受。
            </p>
          </div>
        </div>
      </section>

      {/* Overview pills */}
      <section className="bg-white border-b border-gray-100 py-5">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap gap-2 items-center">
            <span className="text-gray-400 text-[0.875rem] mr-2">快速跳轉：</span>
            {dosageForms.map((d) => (
              <a
                key={d.id}
                href={`#${d.anchor}`}
                className="whitespace-nowrap flex items-center gap-1.5 px-4 py-1.5 rounded-full text-[0.875rem] font-medium bg-[#f7faf7] text-gray-600 border border-gray-200 hover:border-green-300 hover:text-[#4CAF50] transition-all duration-200 cursor-pointer"
              >
                <i className={`${d.icon} text-sm`} />
                {d.title}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Dosage forms */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 space-y-8">
          {dosageForms.map((d) => (
            <div id={d.anchor} key={d.id} className="scroll-mt-24 bg-white rounded-2xl overflow-hidden border border-gray-100">
              <div className="flex flex-col lg:flex-row">
                {/* Image */}
                <div className="w-full lg:w-[320px] flex-shrink-0">
                  <img
                    src={d.img}
                    alt={d.title}
                    className="w-full h-[260px] lg:h-full object-cover object-top"
                  />
                </div>
                {/* Content */}
                <div className="flex-1 p-7">
                  <div className="flex items-start justify-between gap-4 mb-3">
                    <div className="flex items-center gap-3">
                      <div
                        className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
                        style={{ backgroundColor: `${d.colorDark}15` }}
                      >
                        <i className={`${d.icon} text-xl`} style={{ color: d.colorDark }} />
                      </div>
                      <div>
                        <h2 className="text-[#1a2e1a] font-bold text-[1.375rem] leading-tight">{d.title}</h2>
                        <p style={{ color: d.colorDark }} className="text-[0.875rem] font-medium">{d.subtitle}</p>
                      </div>
                    </div>
                    <Link
                      to="/contact/form"
                      className="whitespace-nowrap hidden sm:inline-flex items-center gap-1.5 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.8125rem] px-4 py-2 rounded-full transition-all duration-200 cursor-pointer flex-shrink-0"
                    >
                      洽詢此劑型
                    </Link>
                  </div>

                  <p className="text-gray-600 text-[0.9375rem] leading-[1.75] mb-4">{d.desc}</p>

                  {/* Suitable tags */}
                  <div className="flex flex-wrap gap-1.5 mb-4">
                    {d.suitable.map((s) => (
                      <span
                        key={s}
                        className="text-[0.75rem] font-medium px-2.5 py-1 rounded-full border"
                        style={{ color: d.colorDark, borderColor: `${d.colorDark}30`, backgroundColor: `${d.colorDark}08` }}
                      >
                        {s}
                      </span>
                    ))}
                  </div>

                  {/* Toggle detail */}
                  <button
                    onClick={() => setOpenDetail(openDetail === d.id ? null : d.id)}
                    className="flex items-center gap-2 text-[#4CAF50] font-medium text-[0.875rem] cursor-pointer hover:text-[#43a047] transition-colors duration-200"
                  >
                    <i className={`${openDetail === d.id ? 'ri-subtract-line' : 'ri-add-line'} text-base`} />
                    {openDetail === d.id ? '收合詳細資訊' : '查看製程與優勢'}
                  </button>

                  {openDetail === d.id && (
                    <div className="mt-4 pt-4 border-t border-gray-100 grid grid-cols-1 md:grid-cols-2 gap-5">
                      {/* Process */}
                      <div className="bg-[#f7faf7] rounded-xl p-5">
                        <p className="text-[#1a2e1a] font-bold text-[0.875rem] mb-3 flex items-center gap-2">
                          <i className="ri-settings-3-line text-[#4CAF50]" />
                          製程簡述
                        </p>
                        <p className="text-gray-600 text-[0.8125rem] leading-[1.9] whitespace-pre-line">{d.process}</p>
                      </div>
                      {/* Advantages */}
                      <div className="bg-[#f7faf7] rounded-xl p-5">
                        <p className="text-[#1a2e1a] font-bold text-[0.875rem] mb-3 flex items-center gap-2">
                          <i className="ri-star-line text-[#4CAF50]" />
                          劑型優勢
                        </p>
                        <ul className="space-y-2">
                          {d.advantages.map((a) => (
                            <li key={a} className="flex items-start gap-2">
                              <i className="ri-checkbox-circle-fill text-[#4CAF50] text-sm flex-shrink-0 mt-0.5" />
                              <span className="text-gray-600 text-[0.8125rem] leading-[1.65]">{a}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      {/* Note */}
                      <div className="md:col-span-2 bg-amber-50 border border-amber-100 rounded-xl p-5">
                        <p className="text-[#1a2e1a] font-bold text-[0.875rem] mb-1.5 flex items-center gap-2">
                          <i className="ri-information-line text-amber-500" />
                          注意事項
                        </p>
                        <p className="text-gray-600 text-[0.8125rem] leading-[1.85]">{d.note}</p>
                      </div>
                      <div className="md:col-span-2">
                        <Link
                          to="/contact/form"
                          className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.9375rem] px-7 py-3 rounded-full transition-all duration-300 cursor-pointer"
                        >
                          洽詢此劑型
                          <i className="ri-arrow-right-line" />
                        </Link>
                      </div>
                    </div>
                  )}

                  {/* Mobile CTA */}
                  <div className="mt-4 sm:hidden">
                    <Link
                      to="/contact/form"
                      className="whitespace-nowrap inline-flex items-center gap-1.5 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.875rem] px-5 py-2.5 rounded-full transition-all duration-200 cursor-pointer"
                    >
                      洽詢此劑型
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] leading-tight mb-4">
            不確定哪種劑型最適合您的產品？
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto mb-8">
            康永研發團隊可依據您的配方特性、目標族群與市場定位，給出最專業的劑型選擇建議。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              免費劑型諮詢
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services/hot-formulas"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看熱銷配方
            </Link>
          </div>
        </div>
      </section>
      <ServiceSubNav
        items={SERVICE_SUBNAV_ITEMS}
        backLabel="返回服務總覽"
        backPath="/services"
        sectionLabel="其他服務頁面"
      />
      <RelatedPages items={[
        { title: '熱銷配方', desc: '了解 17 大市場熱銷配方方向，搭配合適劑型打造熱銷品。', href: '/services/hot-formulas' },
        { title: '包裝設計', desc: '劑型確定後，選擇最能展現品牌形象的包材與視覺設計。', href: '/services/packaging' },
        { title: '立即洽詢', desc: '填寫諮詢表單，讓康永協助您選擇最適合的劑型方案。', href: '/contact/form' },
      ]} />
    </>
  );
}
